export default function points (num: number) : string {
	return `${num.toLocaleString()} point${num === 1 ? '' : 's'}`
}
